/**
 * True while an IME is composing (Japanese / Chinese / Korean / etc.).
 *
 * Chromium reports `isComposing` during composition. WebKit (Safari and the
 * macOS desktop app's WKWebView) reports the confirming Enter as
 * `key: "Enter"` with `isComposing === false` and `keyCode === 229`.
 */
export const isComposingEvent = (e: KeyboardEvent) => e.isComposing || e.keyCode === 229;
